<template>
    <phone-select-drawer ref="select_drawer" @select="handleSelect"></phone-select-drawer>
</template>

<script>
import phoneSelectDrawer from '@/components/PhoneSelectDrawer'
import {getTagOptions} from "@/api/payment";
const months = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
]
export default {
    name: "DateSelectDrawer",
    components: {phoneSelectDrawer},
    inject: ['setLoading'],
    methods: {
        init(defaultValue = this.$formatDate(new Date(), 'yyyy年M月'), title = '请选择日期') {
            // this.setLoading(true)
            getTagOptions().then(res => {
                const startYear = res.data['startYear'] || 2025
                const options = []
                const thisYear = new Date().getFullYear()
                const thisMonth = new Date().getMonth() + 1
                for (let i = thisYear; i >= startYear; i--) {
                    options.push([{
                        label: i + '年',
                        value: i + '年',
                    }])
                    // 根据年份决定添加哪些月份
                    if (i === thisYear) {
                        // 当前年份：只添加小于等于当前月份的选项
                        options.push(months
                            .filter(month => month <= thisMonth)
                            .map(month => ({
                                label: `${month}月`,
                                value: `${i}年${month}月`,
                            }))
                        );
                    } else {
                        // 往年：添加全年12个月
                        options.push(months.map(month => ({
                            label: `${month}月`,
                            value: `${i}年${month}月`,
                        })));
                    }
                }
                this.$refs['select_drawer'].init({
                    key: 'date',
                    title: title,
                    value: defaultValue,
                    itemCount: 4,
                    options: options
                })
            }).finally(() => {
                // this.setLoading(false)
            })
        },
        handleSelect(key, item) {
            this.$emit('select', item.value)
        }
    }
}
</script>

<style lang="less" scoped>

</style>
